import React, { Component } from 'react';
import './InventoryDetailsRow.css';
import Label from '../../../../components/label/Label';
import Icon from '../../../../components/icon/Icon';
import models from '../../../../model/models';
import objUtils from '../../../../utils/objUtils';
import utils from '../../../../utils/utils';
import Chart from 'chart.js';
import cloneDeep from 'lodash.clonedeep';
import Divider from '../../../../components/divider/Divider';
import history from '../../../../history';

let displayTypes = (drugs, counts) => {
	if (!drugs) return;
	let display = [];
	let colors = ['orange', 'blue', 'gray', 'green'];
	let count = 0;
	let { orange, gray, green, blue } = counts || {};

	return (
		<div className="intervals">
			<div>
				<div className={'dot  orange'} />
				<Label medium-small black bold>
					Expired
				</Label>
				<Label gray-medium small>
					{orange || 0} vials
				</Label>
			</div>
			<div>
				<div className={'dot  gary'} />
				<Label medium-small black bold>
					0 - 30 days
				</Label>
				<Label gray-medium small>
					{gray || 0} vials
				</Label>
			</div>
			<div>
				<div className={'dot  green'} />
				<Label medium-small black bold>
					30 - 60 days
				</Label>
				<Label gray-medium small>
					{green || 0} vials
				</Label>
			</div>
			<div>
				<div className={'dot  blue open'} />
				<Label medium-small black bold>
					60+ days
				</Label>
				<Label gray-medium small>
					{blue || 0} vials
				</Label>
			</div>
		</div>
	);
};

let drawChart = (type, data) => {
	let element = document.getElementById('ExpirationPieChart' + type);
	if (!element) return;
	let labels = ['expired', '0 - 30 days ', '30 - 60 days ', '60+ '];
	var ctx = element.getContext('2d');
	var chart = new Chart(ctx, {
		type: 'doughnut',
		options: {
			maintainAspectRatio: true,
			legend: { display: false },
			cutoutPercentage: 85

			// tooltips:{
			//   callbacks:{
			//     label:function(tooltipItem, data){
			//       return "verified by john doe" + data
			//     }
			//   }
			// },
			// scales: {yAxes: [{display: false}], xAxes: [{display: false}]}
		},
		data: {
			datasets: [
				{
					borderWidth: -10,
					backgroundColor: ['#ea7e57', '#5d6b81', '#69c09e', '#2091f1'],
					data: data
				}
			],

			// These labels appear in the legend and in the tooltips when hovering different arcs
			labels
		}
	});
};

function expSort(a, b) {
	if (!a.expiration_date) return 0;
	if (!b.expiration_date) return 0;
	return a.expiration_date.getTime() - b.expiration_date.getTime();
}

let getColor = (drug) => {
	let thirtyDays = 1000 * 60 * 60 * 24 * 30;
	let sixtyDays = 1000 * 60 * 60 * 24 * 60;
	if (drug.expiration_date.getTime() < Date.now()) {
		return 'orange';
	} else if (drug.expiration_date.getTime() - Date.now() < thirtyDays) {
		return 'gray';
	} else if (drug.expiration_date.getTime() - Date.now() < sixtyDays) {
		return 'green';
	} else {
		return 'blue';
	}
};

export default class InventoryDetailsRow extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount = () => {
		this.subId = models.drug.onChange(() => {
			this._prepChart(this.props);
		});
		// setTimeout(() => {
		//   this._prepChart();
		// }, 500);
	};
	componentWillReceiveProps(nextProps, nextContext) {
		this._prepChart(nextProps);
	}

	componentWillUnmount = () => {
		models.drug.unsubscribe(this.subId);
	};

	_prepChart = (props) => {
		let res = { gray: 0, green: 0, blue: 0, orange: 0 };
		let drugs = models.drug.objs();
		for (let i in drugs) {
			let drug = drugs[i];
			if (drug.stock_move_record__quantity <= 0) continue;
			if (drug.type !== props.type) continue;
			// if (drug.expiration_date.getTime() < Date.now()) continue;
			let color = getColor(drug);
			res[color]++;
		}
		let data = [res.orange, res.gray, res.green, res.blue];
		this.setState({ counts: res });
		drawChart(this.props.type, data);
	};

	_renderVials = () => {
		let drugs = models.drug.objs();
		drugs = objUtils.to_array(cloneDeep(drugs));
		drugs.sort(expSort);
		let display = [];
		for (let i in drugs) {
			let drug = drugs[i];
			if (drug.stock_move_record__quantity <= 0) continue;
			if (drug.type !== this.props.type) continue;
			let color = getColor(drug);
			let drugBox = models.drug_box.obj(drug.drug_box_id) || {};
			let unit = models.unit.obj(drugBox.unit_id) || {};
			display.push(
				<div className="vial" key={i}>
					<Icon
						onClick={() => {
							history.navigate(`/drug/${drug.id}`);
						}}
						size="large"
						name={'vial-fill-' + color}
					/>
					<div className={'info ' + color}>
						<Label white bold>
							{drug.type}
						</Label>
						<Label white>{drug.barcode_id}</Label>
						<Label white>{unit.name}</Label>
						<Label white>Exp {utils.display_date(drug.expiration_date)}</Label>
					</div>
				</div>
			);
		}
		return <div className="vials">{display}</div>;
	};

	render() {
		let drugs = models.drug.objs();
		return (
			<div className="g-inventory-details-row">
				<Divider />
				<div className="top-row">
					<Label black>EXPIRATION</Label>
				</div>
				<div className="content">
					<div className="row vialRow">
						<div className="graph">
							<canvas id={'ExpirationPieChart' + this.props.type} />
						</div>
						{displayTypes(drugs, this.state.counts)}
					</div>
					{this._renderVials()}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/dashboardPage/inventoryOverviewCard/inventoryDetailsRow/InventoryDetailsRow.jsx